import React from 'react'
import Cookie from 'js-cookie'
import axios from '@/utils/myaxios'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import {
    Button,
    Table,
    message,
    Input,
    Select,
    Tooltip,
    Tag,
    Card,
    Modal,
    Form,
    Switch,
    Radio,
    InputNumber,
    Row,
    Col,
    Statistic,
    Dropdown,
    Icon,
    Menu,
    Descriptions,
} from 'antd'

export default class UnionList extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        loading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            search_value: undefined,
        },
        applicationQueryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
        },
        formData: {
            // 表单数据
            is_kpoker: undefined,
            union_name: undefined,
            user_id: undefined,
            avail_fee_rate: undefined,
            avail_ins_rate: undefined,
            avail_cowboy_rate: undefined,
            api_prop_cost_rate: undefined,
            ins_mod: undefined,
            cowboy_mod: undefined,
        },
        data: [], // 表格数据
        dataInfo: {}, // 数据信息
        selectedData: {}, // 选中数据
    }

    componentDidMount () {
        this.fetchData()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/union_select_union', {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: {
                        ...this.state.queryParams,
                        total: res.count || 0,
                    },
                    data: res.data || [],
                    dataInfo: res || {},
                })
            })
    }

    /**
     * 设置是允许能创建牌局
     */
    handleSetAllowCreate = (display_id, allow) => {
        axios
            .patch('v1/api/union_club_allow_create', {
                id: display_id,
                allow: allow,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["setSuccessMessage"])
                    this.fetchData()
                }
            })
    }

    /**
     * 设置是允许创建免费赛/保底赛
     */
    handleSetAllowCreateFreeMatch = (display_id, allow) => {
        axios
            .patch('v1/api/union_allow_create_free_match ', {
                id: display_id,
                allow: allow,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["setSuccessMessage"])
                    this.fetchData()
                }
            })
    }

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (
                    this.state.type === 'sendIntegral' ||
                    this.state.type === 'recycleIntegral'
                ) {
                    // 发放、回收积分
                    axios
                        .patch('/v1/api/trans_point', {
                            amount:
                                this.state.type === 'sendIntegral'
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.formData.display_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language["operationSuccessMessage"]
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                } else if (
                    this.state.type === 'sendDiamond' ||
                    this.state.type === 'recycleDiamond'
                ) {
                    // 发放、回收钻石
                    axios
                        .patch('/v1/api/diamond/super_union/union', {
                            amount:
                                this.state.type === 'sendDiamond'
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            id: Number(this.state.formData.display_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language["operationSuccessMessage"]
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                } else if (this.state.type === 'contribution') {
                    // 更新服务费贡献比例设置
                    axios
                        .patch('/v1/api/super_union_modify_club_rebate', {
                            win: Number(values.win),
                            lose: Number(values.lose),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language["operationSuccessMessage"]
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                } else if (this.state.type === 'editProportion') {
                    // 编辑分成
                    axios
                        .patch(
                            `/v1/api/union_modify_proportion/${this.state.formData.display_id}`,
                            {
                                avail_fee_rate: Number(values.avail_fee_rate),
                                avail_ins_rate: Number(values.avail_ins_rate),
                                avail_cowboy_rate: Number(
                                    values.avail_cowboy_rate
                                ),
                                api_prop_cost_rate: Number(
                                    values.api_prop_cost_rate
                                ),
                                ins_mod: Number(values.ins_mod),
                                cowboy_mod: Number(values.cowboy_mod),
                            }
                        )
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language["operationSuccessMessage"]
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                } else if (this.state.type === 'create') {
                    // 创建联盟
                    axios
                        .post('/v1/api/union_create_child', {
                            is_kpoker: values.is_kpoker,
                            union_name: values.union_name,
                            user_id: Number(values.user_id),
                            avail_fee_rate: Number(values.avail_fee_rate),
                            avail_ins_rate: Number(values.avail_ins_rate),
                            avail_cowboy_rate: Number(values.avail_cowboy_rate),
                            api_prop_cost_rate: Number(
                                values.api_prop_cost_rate
                            ),
                            ins_mod: Number(values.ins_mod),
                            cowboy_mod: Number(values.cowboy_mod),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language["createSuccessMessage"]
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                }
            }
        })
    }

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        let title
        switch (type) {
            case 'sendIntegral':
                title = this.props.language["sendIntergral"]
                break
            case 'recycleIntegral':
                title = this.props.language["recycleIntergral"]
                break
            case 'sendDiamond':
                title = this.props.language["sendDiamond"]
                break
            case 'recycleDiamond':
                title = this.props.language["recycleDiamond"]
                break
            case 'editProportion':
                title = this.props.language["editProportion"]
                break
            case 'create':
                title = this.props.language["createUnion"]
                break
            case 'contribution':
                title =
                    this.props.language["currentSuperUnionServiceFeeContribution"]
                break
            case 'accountInfo':
                title =
                    this.props.language["accountInfo"]
                break
        }
        let formData = {}
        let selectedData = {}
        if (type === 'contribution') {
            formData = {
                win: this.state.dataInfo.positive_profit_prop,
                lose: this.state.dataInfo.negative_profit_prop,
            }
        } else if (type === 'accountInfo') {
            selectedData = item
        } else if (type !== 'create') {
            formData = {
                display_id: item.display_id,
                is_kpoker: item.kpoker_mode === 1,
                avail_fee_rate: item.fee_proportion,
                avail_ins_rate: item.insurance_proportion,
                avail_cowboy_rate: item.cowboy_proportion,
                api_prop_cost_rate: item.api_prop_cost_proportion,
                ins_mod: item.ins_mod || undefined,
                cowboy_mod: item.cowboy_mod || undefined,
            }
        }
        this.setState({
            show: true,
            type,
            title,
            formData: formData,
            selectedData: selectedData,
        })
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false })
    }

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        )
    }

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        })
    }

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    search_value: undefined,
                },
            },
            () => {
                this.fetchData()
            }
        )
    }

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    {/* <Input
                        allowClear
                        placeholder={this.props.language["searchContentPlaceholder"]}
                        value={this.state.queryParams.search_value}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("search_value", e.target.value)
                        }
                    />
                    <Button type="primary" icon="search" loading={this.state.loading} onClick={this.fetchData}>{this.props.language["query"]}</Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>{this.props.language["reset"]}</Button> */}
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('create')}
                    >
                        {this.props.language["createUnion"]}
                    </Button>
                </div>

                {/* 概况 */}
                <Row type="flex" className="m10 mb0">
                    {/* 柜台积分 */}
                    <div className="number-box-list">
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.point || 0
                                    )}
                                />
                                <p className="label">
                                    {this.props.language["counterPoint"]}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 柜台钻石 */}
                    <div className="number-box-list">
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.diamond || 0
                                    )}
                                />
                                <p className="label">
                                    {this.props.language["counterDiamond"]}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 本超盟服务费贡献比例 */}
                    <div className="number-box-list">
                        <p className="title">
                            {
                                this.props.language
                                    .currentSuperUnionServiceFeeContribution
                            }
                        </p>
                        <Button
                            className="btn"
                            shape="circle"
                            icon="edit"
                            type="primary"
                            ghost
                            onClick={() => this.handleShow('contribution')}
                        ></Button>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo
                                            .positive_profit_prop || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">
                                    {this.props.language["winner"]}
                                </p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo
                                            .negative_profit_prop || 0
                                    )}
                                    suffix="%"
                                />
                                <p>{this.props.language["underdog"]}</p>
                            </div>
                        </div>
                    </div>
                </Row>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ['10', '20', '30', '40'],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["unionId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/union_detail/${item.display_id}`}>
                                    {item.display_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["unionName"]}
                            dataIndex="name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["unionOwnerId"]}
                            dataIndex="user_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["unionOwnerName"]}
                            dataIndex="user_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["joinSuperUnionTime"]}
                            dataIndex="join_super_union_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["kpokerUnion"]}
                            dataIndex=""
                            render={(item) =>
                                item.kpoker_mode === 1 ? (
                                    <Tag color="blue">
                                        {this.props.language["yes"]}
                                    </Tag>
                                ) : (
                                    <Tag>{this.props.language["no"]}</Tag>
                                )
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["clubNumber"]}
                            dataIndex="club_number"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyAmount"]}
                            render={(item) => {
                                return (
                                    <div>
                                        <Tooltip
                                            title={
                                                this.props.language["superProxy"]
                                            }
                                        >
                                            <Tag color="purple">
                                                {
                                                    item.union_member_cnt
                                                        .super_agent_cnt
                                                }
                                            </Tag>
                                        </Tooltip>
                                        <Tooltip
                                            title={this.props.language["oneProxy"]}
                                        >
                                            <Tag color="geekblue">
                                                {
                                                    item.union_member_cnt
                                                        .agent_cnt
                                                }
                                            </Tag>
                                        </Tooltip>
                                        <Tooltip
                                            title={this.props.language["twoProxy"]}
                                        >
                                            <Tag color="blue">
                                                {
                                                    item.union_member_cnt
                                                        .agent2_cnt
                                                }
                                            </Tag>
                                        </Tooltip>
                                        <Tooltip
                                            title={
                                                this.props.language["threeProxy"]
                                            }
                                        >
                                            <Tag color="cyan">
                                                {
                                                    item.union_member_cnt
                                                        .agent3_cnt
                                                }
                                            </Tag>
                                        </Tooltip>
                                        <Tooltip
                                            title={
                                                this.props.language["fourProxy"]
                                            }
                                        >
                                            <Tag color="green">
                                                {
                                                    item.union_member_cnt
                                                        .agent4_cnt
                                                }
                                            </Tag>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["palyerNumber"]}
                            dataIndex="union_member_cnt.user_cnt"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["counterPoint"]}
                            dataIndex="point"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["counterDiamond"]}
                            dataIndex="diamond"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceProportion"]}
                            dataIndex=""
                            render={(item) => `${item.fee_proportion}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProportion"]}
                            dataIndex=""
                            render={(item) => `${item.insurance_proportion}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProportion"]}
                            dataIndex=""
                            render={(item) => `${item.cowboy_proportion}%`}
                        />
                        {Cookie.get('isKpoker') === 'true' && (
                            <Table.Column
                                align="center"
                                title={this.props.language["propCusomeProportion"]}
                                dataIndex=""
                                render={(item) =>
                                    `${item.api_prop_cost_proportion}%`
                                }
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceDivide"]}
                            dataIndex=""
                            render={(item) =>
                                `${item.ins_mod === 1
                                    ? this.props.language["risk"]
                                    : 'EV'
                                }`
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyDivide"]}
                            dataIndex=""
                            render={(item) =>
                                `${item.cowboy_mod === 1
                                    ? this.props.language["risk"]
                                    : 'EV'
                                }`
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["allowCreateFreeMatch"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={120}
                            render={(item) => {
                                return (
                                    <Switch
                                        checked={item.allow_free_match}
                                        onChange={(value) =>
                                            this.handleSetAllowCreateFreeMatch(
                                                item.display_id,
                                                value
                                            )
                                        }
                                    />
                                )
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["allowCreateTable"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={120}
                            render={(item) => {
                                return (
                                    <Switch
                                        checked={item.allow_create === 1}
                                        onChange={(value) =>
                                            this.handleSetAllowCreate(
                                                item.display_id,
                                                value
                                            )
                                        }
                                    />
                                )
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={220}
                            render={(item) => (
                                <>
                                    {item.kpoker_mode === 1 &&
                                        <Button className="mr10" type="default" onClick={() => this.handleShow('accountInfo', item)}>
                                            {this.props.language["accountInfo"]}
                                        </Button>
                                    }
                                    <Dropdown
                                        trigger={['click']}
                                        overlay={
                                            <Menu
                                                onClick={({ key }) =>
                                                    this.handleShow(key, item)
                                                }
                                            >
                                                <Menu.Item key="sendIntegral">
                                                    {
                                                        this.props.language
                                                            .sendIntergral
                                                    }
                                                </Menu.Item>
                                                <Menu.Item key="recycleIntegral">
                                                    {
                                                        this.props.language
                                                            .recycleIntergral
                                                    }
                                                </Menu.Item>
                                                <Menu.Item key="sendDiamond">
                                                    {
                                                        this.props.language
                                                            .sendDiamond
                                                    }
                                                </Menu.Item>
                                                <Menu.Item key="recycleDiamond">
                                                    {
                                                        this.props.language
                                                            .recycleDiamond
                                                    }
                                                </Menu.Item>
                                                <Menu.Item key="editProportion">
                                                    {
                                                        this.props.language
                                                            .editProportion
                                                    }
                                                </Menu.Item>
                                            </Menu>
                                        }
                                    >
                                        <Button type="primary" ghost>
                                            {this.props.language["operation"]}
                                            <Icon type="down" />
                                        </Button>
                                    </Dropdown>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    dataInfo={this.state.dataInfo}
                    selectedData={this.state.selectedData}
                    onOk={this.handleSubmit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}
                    footer={
                        this.props.type !== 'accountInfo' ? (
                            <>
                                <Button
                                    type="default"
                                    onClick={this.props.onCancel}
                                >
                                    {this.props.language['cancel']}
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={this.props.onOk}
                                >
                                    {this.props.language['confirm']}
                                </Button>
                            </>
                        ) : (
                            false
                        )
                    }
                >
                    <div className="container-content">
                        <Form>
                            {/* 创建联盟 */}
                            {this.props.type === 'create' && (
                                <>
                                    {Cookie.get('isKpoker') === 'true' && (
                                        <Form.Item
                                            label={
                                                this.props.language["kpokerUnion"]
                                            }
                                        >
                                            {getFieldDecorator('is_kpoker', {
                                                rules: [{ required: false }],
                                            })(<Switch />)}
                                        </Form.Item>
                                    )}
                                    <Form.Item
                                        label={this.props.language["unionName"]}
                                    >
                                        {getFieldDecorator('union_name', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .unionNameVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.union_name,
                                        })(
                                            <Input
                                                allowClear
                                                maxLength={10}
                                                placeholder={
                                                    this.props.language
                                                        .unionNamePlaceholder
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    {!getFieldValue('is_kpoker') && <Form.Item
                                        label={this.props.language["unionOwnerId"]}
                                    >
                                        {getFieldDecorator('user_id', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .unionOwnerIdVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.user_id,
                                        })(
                                            <InputNumber
                                                precision={0}
                                                min={0}
                                                max={100000000}
                                                placeholder={
                                                    this.props.language
                                                        .unionOwnerIdPlaceholder
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    }
                                    <Form.Item
                                        label={
                                            this.props.language
                                                .serviceProportion
                                        }
                                    >
                                        {getFieldDecorator('avail_fee_rate', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .serviceProportionVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_fee_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language
                                                        .serviceProportionPlaceholder
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language
                                                .insuranceProportion
                                        }
                                    >
                                        {getFieldDecorator('avail_ins_rate', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .insuranceProportionVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_ins_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language
                                                        .insuranceProportionPlaceholder
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language["cowboyProportion"]
                                        }
                                    >
                                        {getFieldDecorator(
                                            'avail_cowboy_rate',
                                            {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language
                                                                .cowboyProportionVerify,
                                                    },
                                                ],
                                                initialValue: this.props.formData.avail_cowboy_rate,
                                            }
                                        )(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language
                                                        .cowboyProportionPlaceholder
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    {getFieldValue('is_kpoker') && (
                                        <Form.Item
                                            label={
                                                this.props.language
                                                    .propCusomeProportion
                                            }
                                        >
                                            {getFieldDecorator(
                                                'api_prop_cost_rate',
                                                {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                this.props
                                                                    .language
                                                                    .propCusomeProportionVerify,
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.api_prop_cost_rate,
                                                }
                                            )(
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    precision={0}
                                                    placeholder={
                                                        this.props.language
                                                            .propCusomeProportionPlaceholder
                                                    }
                                                    formatter={(value) =>
                                                        `${value}%`
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    )}
                                    <Form.Item
                                        label={
                                            this.props.language["insuranceDivide"]
                                        }
                                    >
                                        {getFieldDecorator('ins_mod', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .insuranceDivideVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.ins_mod,
                                        })(
                                            <Radio.Group
                                            >
                                                <Radio value={1}>
                                                    {this.props.language["risk"]}
                                                </Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={this.props.language["cowboyDivide"]}
                                    >
                                        {getFieldDecorator('cowboy_mod', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .cowboyDivideVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.cowboy_mod,
                                        })(
                                            <Radio.Group
                                            >
                                                <Radio value={1}>
                                                    {this.props.language["risk"]}
                                                </Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 编辑分成 */}
                            {this.props.type === 'editProportion' && (
                                <>
                                    <Form.Item
                                        label={
                                            this.props.language
                                                .serviceProportion
                                        }
                                    >
                                        {getFieldDecorator('avail_fee_rate', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .serviceProportionVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_fee_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language
                                                        .serviceProportionPlaceholder
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language
                                                .insuranceProportion
                                        }
                                    >
                                        {getFieldDecorator('avail_ins_rate', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .insuranceProportionVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_ins_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language
                                                        .insuranceProportionPlaceholder
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            this.props.language["cowboyProportion"]
                                        }
                                    >
                                        {getFieldDecorator(
                                            'avail_cowboy_rate',
                                            {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language
                                                                .cowboyProportionVerify,
                                                    },
                                                ],
                                                initialValue: this.props.formData.avail_cowboy_rate,
                                            }
                                        )(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language
                                                        .cowboyProportionPlaceholder
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    {getFieldValue('is_kpoker') && (
                                        <Form.Item
                                            label={
                                                this.props.language
                                                    .propCusomeProportion
                                            }
                                        >
                                            {getFieldDecorator(
                                                'api_prop_cost_rate',
                                                {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                this.props
                                                                    .language
                                                                    .propCusomeProportionVerify,
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.api_prop_cost_rate,
                                                }
                                            )(
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    precision={0}
                                                    placeholder={
                                                        this.props.language
                                                            .propCusomeProportionPlaceholder
                                                    }
                                                    formatter={(value) =>
                                                        `${value}%`
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    )}
                                    <Form.Item
                                        label={
                                            this.props.language["insuranceDivide"]
                                        }
                                    >
                                        {getFieldDecorator('ins_mod', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .insuranceDivideVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.ins_mod,
                                        })(
                                            <Radio.Group
                                            >
                                                <Radio value={1}>
                                                    {this.props.language["risk"]}
                                                </Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={this.props.language["cowboyDivide"]}
                                    >
                                        {getFieldDecorator('cowboy_mod', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .cowboyDivideVerify,
                                                },
                                            ],
                                            initialValue: this.props.formData.cowboy_mod,
                                        })(
                                            <Radio.Group
                                            >
                                                <Radio value={1}>
                                                    {this.props.language["risk"]}
                                                </Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 发放回收积分/钻石 */}
                            {(this.props.type == 'sendIntegral' ||
                                this.props.type == 'recycleIntegral' ||
                                this.props.type == 'sendDiamond' ||
                                this.props.type == 'recycleDiamond') && (
                                    <>
                                        <Form.Item
                                            label={this.props.language["amount"]}
                                        >
                                            {getFieldDecorator('amount', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language
                                                                .amountVerify,
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    min={1}
                                                    max={100000000}
                                                    precision={0}
                                                    placeholder={
                                                        this.props.language
                                                            .amountPlaceholder
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}

                            {/* 本超盟服务费贡献比例 */}
                            {this.props.type === 'contribution' && (
                                <>
                                    <Form.Item
                                        label={this.props.language["winner"]}
                                    >
                                        {getFieldDecorator('win', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .winnerProportionPlaceholder,
                                                },
                                            ],
                                            initialValue: this.props.formData.win,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language
                                                        .winnerProportionPlaceholder
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={this.props.language["underdog"]}
                                    >
                                        {getFieldDecorator('lose', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language
                                                            .loserProportionPlaceholder,
                                                },
                                            ],
                                            initialValue: this.props.formData.lose,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language
                                                        .loserProportionPlaceholder
                                                }
                                                formatter={(value) =>
                                                    `${value}%`
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 账号信息 */}
                            {this.props.type === 'accountInfo' && (
                                <Descriptions size="small" column={1}>
                                    <Descriptions.Item label={this.props.language["account"]}>
                                        {this.props.selectedData.api_union_info.account}
                                    </Descriptions.Item>
                                    <Descriptions.Item label={this.props.language["initPassword"]}>
                                        {this.props.selectedData.api_union_info.default_passwd}
                                    </Descriptions.Item>
                                </Descriptions>
                            )}
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)
